import { RnHazard } from "@remi/icons/next";
import { RemiButton } from "@remi/next-ui";

import { useUserProfile } from "~/contexts/UserProfileContext";
import { useEndImpersonation } from "~/hooks/useImpersonation";

export const ImpersonationWarning = () => {
  const { user } = useUserProfile();

  const endImpersonation = useEndImpersonation();

  if (!user.imposterId) {
    return null;
  }

  return (
    <div className="flex w-full justify-between border-border-accent border-b-[1px] bg-background-accentLight p-4">
      <div className="flex items-center">
        <RnHazard className="text-icon-primary" />
        <div className="ml-3">
          <p className="text-text-primary text-xs">You are currently impersonating someone else</p>
        </div>
      </div>
      <RemiButton
        variant="accent"
        size="custom"
        className="text-xs"
        loading={endImpersonation.isPending}
        onClick={() => endImpersonation.mutate()}
      >
        Stop impersonation
      </RemiButton>
    </div>
  );
};
